(function(){'use strict';function replaceText(root,from,to){if(!root)return;var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),n=[];while(w.nextNode())n.push(w.currentNode);n.forEach(function(x){if(x.nodeValue&&x.nodeValue.indexOf(from)>-1)x.nodeValue=x.nodeValue.split(from).join(to)})}function polish(){var school=document.querySelector('.school-offer');replaceText(school,'90-DAY','90-NIGHT');replaceText(document.querySelector('.campaign-page'),'4–7 days in North America','4–6 days in North America');replaceText(document.querySelector('.utility-page'),'4–7 days in North America','4–6 days in North America');var proEmoji=document.querySelector('.pick-grid .pick-card:nth-child(2) .pc-emoji');if(proEmoji)proEmoji.textContent='🌈';var readout=document.getElementById('signalReadout');if(readout&&window.MutationObserver){var clean=function(){if(readout.textContent.indexOf('Your partner never knows')>-1)readout.textContent='Cue felt. Your signal stays personal.'};new MutationObserver(clean).observe(readout,{childList:true,subtree:true,characterData:true});clean()}}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',polish);else polish();})();

/* Every Second Matters — personalized 24-hour wheel.
   Two required quick-picks (sleep, work/study) plus two optional ones (commute, screen time)
   drive four of six wedges directly from the visitor's own taps. The remaining two wedges
   (meals & chores, free time) fill in from typical daily averages using whatever time is left,
   so the wheel always totals a full 24 hours. Every tap redraws the wheel and lifetime-year
   results immediately — no submit step. */
(function(){
  var card = document.getElementById('dayWheelCard');
  if(!card) return;
  var wheel = document.getElementById('dayWheel');
  var legEls = {
    sleep: document.getElementById('legSleepH'),
    work: document.getElementById('legWorkH'),
    commute: document.getElementById('legCommuteH'),
    screen: document.getElementById('legScreenH'),
    chores: document.getElementById('legChoresH'),
    free: document.getElementById('legFreeH')
  };
  var lifeEls = {
    sleep: document.getElementById('dwLifeSleep'),
    work: document.getElementById('dwLifeWork'),
    commute: document.getElementById('dwLifeCommute'),
    screen: document.getElementById('dwLifeScreen'),
    chores: document.getElementById('dwLifeChores'),
    free: document.getElementById('dwLifeFree')
  };
  var COLORS = {
    sleep: 'var(--cyan)',
    work: '#5271ff',
    commute: 'var(--gold)',
    screen: '#ff7b72',
    chores: '#8ee6a3',
    free: '#9f7aea'
  };
  var ORDER = ['sleep','work','commute','screen','chores','free'];
  var LIFE_YEARS = 80;
  var CHORES_AVG = 2.5; // typical daily average for meals & everyday chores
  var state = { sleep: 8, work: 8, commute: 1, screen: 3 };

  function fmtHours(h){
    h = Math.round(h * 10) / 10;
    return (h % 1 === 0 ? h.toFixed(0) : h.toFixed(1)) + 'h';
  }

  function compute(){
    var sleep = state.sleep, work = state.work, commute = state.commute, screen = state.screen;
    var used = sleep + work + commute + screen;
    var chores, free;
    if(used > 24){
      // Answers exceed a real day — scale the four personalized wedges down proportionally
      // so the wheel still totals exactly 24 hours, and leave no room for the averaged wedges.
      var scale = 24 / used;
      sleep *= scale; work *= scale; commute *= scale; screen *= scale;
      chores = 0; free = 0;
    } else {
      var remaining = 24 - used;
      chores = Math.min(CHORES_AVG, remaining);
      free = Math.max(0, remaining - chores);
    }
    return { sleep: sleep, work: work, commute: commute, screen: screen, chores: chores, free: free };
  }

  function render(){
    var hours = compute();

    if(wheel){
      var stops = [];
      var cursor = 0;
      ORDER.forEach(function(key){
        var pct = (hours[key] / 24) * 100;
        var start = cursor;
        var end = cursor + pct;
        stops.push(COLORS[key] + ' ' + start.toFixed(3) + '% ' + end.toFixed(3) + '%');
        cursor = end;
      });
      wheel.style.background = 'conic-gradient(' + stops.join(', ') + ')';
    }

    ORDER.forEach(function(key){
      if(legEls[key]) legEls[key].textContent = fmtHours(hours[key]);
      if(lifeEls[key]) lifeEls[key].textContent = (LIFE_YEARS * (hours[key] / 24)).toFixed(1) + ' yrs';
    });
  }

  function wireGroup(selector, key){
    var group = card.querySelector(selector);
    if(!group) return;
    var btns = Array.prototype.slice.call(group.querySelectorAll('button'));
    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        btns.forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state[key] = parseFloat(btn.getAttribute('data-val')) || 0;
        render();
      });
    });
  }

  wireGroup('[data-quiz="sleep"]', 'sleep');
  wireGroup('[data-quiz="work"]', 'work');
  wireGroup('[data-quiz="commute"]', 'commute');
  wireGroup('[data-quiz="screen"]', 'screen');
  render();
})();
